<template>
  <div class="simpledrop-item user-selector-dropdown" :class="{'selected' : (selectedValue != defaultValue)}">
    <b-dropdown id="user_selector" :text="text" block variant="link" class="simpledrop-item-button" toggle-class="button-no-shadows text-decoration-none">
      <template #button-content>
        <div class="d-flex align-items-center">
          <GkAvatar v-if="selectedUserId" :key="avatarKey" :userId="selectedUserId" />
          <div>{{ text }}</div>
        </div>
      </template>
      <b-dropdown-item v-for="user in userList" :key="user.user.id" @click="selectOption(user.user)" class="list-item">
        {{ user.user.display_name }}
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>
<script>
  import { mapGetters } from "vuex";

  import CompanyOwnerService from "@/store/services/companyowner.service.js";

  export default {
    name: "UserSelector",
    props: {
      value: Object,
    },
    components: { },
    data() {
      return {
        text: '',
        defaultValue: null,
        selected: null,
        userList: [],
        selectedUserId: null,
        avatarKey: 0
      }
    },
    computed: {
      ...mapGetters ({ 
        currentUser: 'main/getCurrentUser',
        getCompanyId: 'main/getCompanyId'
      }),
      selectedValue() {
        return (this.selected) ? this.selected : this.defaultValue
      }
    },
    created(){
      this.getUserList();

    },
    methods: {
      selectOption(option){
        this.selected = option.id;
        this.text = option.display_name;
        this.selectedUserId = option.id
        this.avatarKey++
        this.$emit('input', option);
        this.$emit('change', option);
      },
      getUserList(){
        CompanyOwnerService.list({
          extended: "True",
          company_profile: this.getCompanyId
        }).then((response) => {
          var currentUser = response.data.filter((d) => {
            return d.user.id === this.currentUser.id;
          })[0];
          if (currentUser && !currentUser.rights.access_company_wide_resources) {
            this.userList = [currentUser];
            this.text = this.userList[0].user.display_name;
            this.selectedUserId = this.userList[0].user.id
            this.avatarKey++
            return;
          }
          response.data.unshift({
            user: {
              display_name: this.$gettext('No user selected'),
              id: null
            }
          });
          this.userList = response.data;
          this.text = this.userList[0].user.display_name;
          if (this.value) {
            this.selected = this.value;

            let teamMemberInUserList = this.userList.find(element => element.user.id === this.value.id);
            if (teamMemberInUserList)
              this.text = teamMemberInUserList.user.display_name;
            
            this.selectedUserId = this.value.id
            this.avatarKey++
          }
        })
      }
    }
  }
</script>
<style lang="scss">
  .user-selector-dropdown {
    .btn.dropdown-toggle {
      height: 45px;
    }
    .profile-badge {
      margin-right: 5px;
      margin-bottom: 5px;
      $avatarSize: 25px;
      .avatar { 
        margin: 0; 
        min-width: $avatarSize;
        min-height: $avatarSize;
        width: $avatarSize;
        height: $avatarSize;
      }
      .no-avatar {
        font-size: 14px;
        color: #666;
        width: $avatarSize;
        height: $avatarSize;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #ddd;
        border-radius: 20px;
        padding-top: 2px;
      }
      
    }
  }
  .simpledrop-item {
    .button-no-shadows{
      height: 24px;
      padding: 0;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      text-align: left;
      border: none;
      &:not(:disabled):not(.disabled), &:focus, .focus {
        box-shadow: none !important;
      }
    }
    .dropdown-menu{
      margin-top: 8px;
      font-size: 14px;
    }
    .dropdown-toggle{
      font-size: 15px;
    }
    .dropdown-toggle:after {
      position: absolute;
      right: 8px;
      top: 50%;
      position: absolute;
      margin-top: 1px;
      transform: translateY(-50%);
    }
    white-space: nowrap;
    .simpledrop-item-button {
      width: 100%;
      button{ color: $colorTextBase; }
      text-overflow: ellipsis;
      display: block;
      position: relative;
      padding-right: 20px;
      .dropdown-item{
        padding-left: 10px;
        padding-top: 3px;
        padding-bottom: 3px;
        .fa, .emoji { margin-right: 5px; }
      }
    }
  }
</style>